(() => {
  const normalize = value => String(value || '').trim().toLocaleUpperCase();
  const isApplied = (cart, code) => {
    if (Array.isArray(cart.discount_codes)) {
      return cart.discount_codes.some(discount => normalize(discount.code) === normalize(code) && discount.applicable === true);
    }
    const discounts = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
    return discounts.some(discount => discount.type === 'discount_code' && normalize(discount.title) === normalize(code));
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { isApplied };
  if (typeof document === 'undefined') return;

  let pending = false;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-pg-discount]');
    if (!form) return;
    event.preventDefault();
    if (pending) return;
    const formId = form.id;
    const drawer = form.closest('cart-drawer');
    const input = form.querySelector('input[name="discount"]');
    const code = input.value.trim();
    if (!code) { input.focus(); return; }
    const existing = [...new Set((form.dataset.appliedCodes || '').split(',').map(value => value.trim()).filter(Boolean))];
    const codes = [...existing.filter(value => normalize(value) !== normalize(code)), code];
    const targets = ['main-cart-items', 'main-cart-footer'].map(id => ({ id, section: document.getElementById(id)?.dataset.id, selector: '.js-contents' })).filter(target => target.section);
    if (document.getElementById('CartDrawer')) targets.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
    targets.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    const status = form.querySelector('[role="status"]');
    const button = form.querySelector('button');
    pending = true;
    form.setAttribute('aria-busy', 'true'); button.disabled = true;
    status.textContent = 'Verificăm codul…';
    let message;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(','), sections: targets.map(target => target.section), sections_url: window.location.pathname })
      });
      const cart = await response.json();
      if (!response.ok || cart.status) throw new Error('discount-request');
      message = isApplied(cart, code) ? `Codul ${code} a fost aplicat.` : 'Codul nu este valid sau nu se aplică produselor din coș.';
      const fragments = targets.map(target => {
        const html = cart.sections?.[target.section];
        const content = html && new DOMParser().parseFromString(html, 'text/html').querySelector(target.selector);
        const element = document.getElementById(target.id);
        return { element: element?.querySelector(target.selector) || element, content };
      });
      // A full reload is a safe fallback if Shopify could not render the requested sections.
      if (fragments.some(fragment => !fragment.element || !fragment.content)) {
        sessionStorage.setItem('pg-discount-status', JSON.stringify({formId, message, code}));
        window.location.reload(); return;
      }
      fragments.forEach(({element, content}) => { element.innerHTML = content.innerHTML; });
      document.querySelector('cart-drawer')?.classList.toggle('is-empty', cart.item_count === 0);
      const updated = document.getElementById(formId);
      if (!updated) return;
      updated.querySelector('[role="status"]').textContent = message;
      updated.querySelector('input[name="discount"]').value = code;
      const updatedInput = updated.querySelector('input[name="discount"]');
      if (drawer?.classList.contains('active') && typeof trapFocus === 'function') trapFocus(drawer.querySelector('.drawer__inner'), updatedInput);
      else updatedInput.focus();
    } catch (error) {
      status.textContent = 'Nu am putut verifica acum codul. Încearcă din nou sau introdu-l la finalizarea comenzii.';
    } finally {
      pending = false;
      form.removeAttribute('aria-busy'); button.disabled = false;
    }
  });
  const restoreStatus = () => {
    const saved = sessionStorage.getItem('pg-discount-status');
    if (!saved) return;
    try {
      const {formId, message, code} = JSON.parse(saved);
      const form = document.getElementById(formId);
      if (!form) return;
      form.querySelector('[data-pg-discount-status]').textContent = message;
      form.querySelector('input[name="discount"]').value = code;
      const drawer = form.closest('cart-drawer');
      drawer?.open();
    } catch (error) { /* Ignore a status saved by an older theme version. */ }
    sessionStorage.removeItem('pg-discount-status');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreStatus); else restoreStatus();
})();
